// Rule disabled because firestore initialization is async
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';
import ReduxSagaFirebase from 'redux-saga-firebase';
import { logError } from '../shared/utils/plog';

firebase.initializeApp({
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY
});

if (process.env.NODE_ENV === 'development') {
  firebase.functions().useEmulator(process.env.REACT_APP_FIREBASE_FUNCTIONS);
  firebase.firestore().settings({ host: process.env.REACT_APP_FIREBASE_DATABASE_URL, ssl: false });
  firebase.auth().useEmulator(`http://${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`);
}

export let firestore = {};
export let storage = {};
export let reduxSagaFireBase = {};
export let auth = {};

export async function initializeFirebase() {
  try {
    storage = firebase.storage();
    auth = firebase.auth();
    firestore = firebase.firestore();
    reduxSagaFireBase = new ReduxSagaFirebase(firebase);
  } catch (e) {
    logError({
      type: 'configuration',
      text: 'firebaseSetup',
      array: ['Failed to setup Firebase utilities', e]
    });
  }
}
